import "./insGridControls.scss";
import { AuxSearchField } from "@blk/aladdin-react-components-es";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { InsGridCurrencySelector } from "./insGridCurrencySelector";
import { setSearch } from "store/grids";
export const InsGridControlsLeft = (props) => {
    const dispatch = useDispatch();
    const search = useSelector((state) => state.grids.state[props.stateId]?.search);
    return React.createElement("div", { className: "gridControls" },
        React.createElement(AuxSearchField, { key: `searchFieldGrid-${props.stateId}`, searchValue: search || "", onSearchValueChanged: (event) => dispatch(setSearch({ id: props.stateId, search: event.detail.submitValue.searchValue || "" })), size: props.small ? "small" : "regular" }),
        React.createElement(InsGridCurrencySelector, { ...props, key: `currencySelector-${props.stateId}` }));
};
